{
    "api_keys": {
        "copied": "API-Schlüssel in die Zwischenablage kopiert.",
        "show_once_warning": "Kopieren Sie diesen Schlüssel jetzt. Aus Sicherheitsgründen wird er nach dem Schließen dieses Dialogs nicht erneut angezeigt.",
        "show_once_info": "Der Schlüssel wird nach der Erstellung nur einmal angezeigt. Bewahren Sie ihn sicher auf, er kann nicht erneut abgerufen werden.",
        "status": {
            "active": "Aktiv",
            "revoked": "Widerrufen",
            "expired": "Abgelaufen"
        }
    },
    "employee": {
        "date_of_birth": "Wird für die Ausstellung einer Karte benötigt. Sie können es jederzeit korrigieren, aber nicht entfernen; niemand sonst sieht es in finway."
    },
    "date_of_birth_required": "Aus regulatorischen Gründen unseres Kartenprogramms müssen wir Ihr Geburtsdatum abfragen, bevor Sie fortfahren können.",
    "date_of_birth_private": "Das Geburtsdatum wird in finway nicht angezeigt und ist lediglich für Sie selbst sichtbar.",
    "prefilled_approver": "Automatisch ausgewählte:r Freigeber:in",
    "vendor_rule": "Falls eine Lieferantenregel für diesen Lieferanten erstellt wurde, werden die Kostenstelle, der Kostenträger und das Sachkonto automatisch befüllt.",
    "allowed_invoice_types": "Zulässige Dateien: PDF, JPG, PNG.",
    "allowed_delivery_note_types": "Zulässige Dateien: PDF, JPG, PNG. Max Größe: 5 MB.",
    "allowed_img_types": "Zulässige Dateien: JPG/JPEG. Max Größe: 5 MB.",
    "yearly_price": "Der jährliche Preis ist $ {{price}}.",
    "monthly_price": "Der monatliche Preis ist $ {{price}}.",
    "uploading_img": "Bilddatei wird hochgeladen...",
    "uploading_file": "Datei wird hochgeladen...",
    "responsible_user": "Sie können nur einen Admin oder Freigeber:in auswählen.",
    "email_update": "Ihre neue Email-Adresse muss noch bestätigt werden bevor sie aktiviert wird.",
    "ocr": {
        "captured": "Erfasst",
        "not_captured": "Fehlgeschlagen",
        "in_progress": "In Bearbeitung",
        "make_sure_ocr_source_is_selected": "Bitte stellen Sie sicher, dass Sie die OCR Quelle in der rechtesten Spalte richtig ausgewählt haben.",
        "iban_mismatch": "OCR hat eine abweichende IBAN erkannt. Die Anpassungen betreffen nur diesen Antrag, nicht die Lieferantenstammdaten.",
        "bic_mismatch": "OCR hat eine abweichende BIC erkannt. Die Anpassungen betreffen nur diesen Antrag, nicht die Lieferantenstammdaten.",
        "failed_hint": "OCR ist fehlgeschlagen. Ein möglicher Grund ist, dass die Dateigröße das OCR-Limit von {{fileSizeLimitMb}} MB überschreitet. Bitte überprüfen Sie Dateigröße und -format."
    },
    "inbox_invoice": {
        "file_name": "Dateiname",
        "upload_date": "Upload-Datum",
        "ocr": "OCR",
        "vendor": "Lieferant",
        "action": "Aktion",
        "uploaded_by": "Hochgeladen von",
        "invoices_from_inbox": "Rechnungen aus dem Eingang",
        "expense_details": "Details des Antrags",
        "invoice_details": "Details der Rechnung",
        "docs_needed_expenses": "Anträge im Status 'Dateien erforderlich'",
        "ocr_source": "OCR Quelle",
        "gross_amount": "Bruttobetrag",
        "amount": "Betrag"
    },
    "verify_email": {
        "title": "Erfolgreiche Bestätigung",
        "message": "Ihre Email-Adresse wurde erfolgreich geändert."
    },
    "card_info_required": "Sie müssen Ihre Kartendetails nochmals eingeben.",
    "empty_state": {
        "requests": {
            "title": "Keine offenen Anträge.",
            "message": "Erstellen Sie einen neuen Antrag um ihn hier anzuzeigen."
        },
        "todo_done": {
            "title": "Super, Sie sind fertig mit allen Aufgaben.",
            "message": "Erstellen Sie einen neuen Antrag."
        },
        "procurement": {
            "title": "Keine offenen Bestellanträge.",
            "message": "Freigegebene Anträge werden hier zur Prüfung aufgelistet."
        },
        "review": {
            "title": "Keine offenen Anträge.",
            "message": "Freigegebene Anträge werden hier zum Prüfen aufgelistet werden."
        },
        "all": {
            "title": "Keine Anträge.",
            "message": "Alle erledigten Anträge werden hier aufgelistet."
        },
        "archive": {
            "title": "Keine Anträge.",
            "message": "Archivierte Anträge werden hier aufgelistet werden."
        },
        "pay_export": {
            "title": "Keine offenen Anträge.",
            "message": "Geprüfte Anträge werden hier zum Bezahlung und Exportieren aufgelistet werden."
        },
        "subscriptions": {
            "title": "Erstellen Sie Ihr erstes Abonnement",
            "message": "Erstellen Sie Ihre ersten Abonnements um sie hier in einer Übersichtstabelle anzuzeigen."
        },
        "subscriptions_employees": {
            "title": "Keine Abonnements verfügbar",
            "message": "Freigegebene Abonnements werden hier angezeigt."
        },
        "employees": {
            "title": "Erstellen Sie Ihre:n erste:n Mitarbeiter:in",
            "message": "Erstellen Sie Ihre:n erste:n Mitarbeiter:in um sie hier in einer Übersichtstabelle anzuzeigen."
        },
        "vendors": {
            "title": "Erstellen Sie Ihren ersten Lieferanten",
            "message": "Erstellen Sie Ihre ersten Lieferanten um sie hier in einer Übersichtstabelle anzuzeigen."
        },
        "workflows": {
            "title": "Erstellen Sie Ihren ersten Workflow",
            "message": "Erstellen Sie Ihren ersten Workflows um sie hier in einer Übersichtstabelle anzuzeigen."
        },
        "cost_centers": {
            "title": "Erstellen Sie Ihre erste Kostenstelle",
            "message": "Erstellen Sie Ihre ersten Kostenstellen um sie hier in einer Übersichtstabelle anzuzeigen."
        },
        "cost_centers_approver": {
            "title": "Keine Kostenstelle verfügbar",
            "message": "Ein Admin muss Sie zu einer Kostenstelle hinzufügen."
        },
        "transactions": {
            "title": "Keine Transaktionen verfügbar",
            "message": "Starten Sie den Matching Prozess, um Transaktionen hier anzuzeigen."
        },
        "kyb": {
            "submitted_title": "Dokumente eingereicht",
            "message_submitted": "Alle KYB-Dokumente wurden eingereicht. Der Verifizierungsprozess kann bis zu 3 Arbeitstage in Anspruch nehmen. Die Karten können nach erfolgreicher Verifizierung ausgegeben werden.",
            "button_home": "Dashboard",
            "button_next": "Weiter",
            "non-admin_title": "Die finway-Karten können Sie in Kürze benutzen",
            "message_non-admin": "Ihr Unternehmen muss zuerst verifiziert werden, um die finway-Karten nutzen zu können.",
            "start_title": "KYB - Know Your Business",
            "start_subtitle": "zur Aktivierung der Kartenfunktion",
            "message_start": "Wenn Sie den KYB-Prozess abgeschlossen haben, können Sie virtuelle und physische Karten ausgeben, um Ihre Ausgaben einfacher zu verwalten. Die Prüfung kann bis zu 4 Werktage in Anspruch nehmen und nur von einem Admin durchgeführt werden. Die KYB-Verifizierung muss von der Person abgeschlossen werden, die sie startet.",
            "loading_title": "Die Daten werden verarbeitet",
            "loading_info": "Dieser Vorgang dauert ein paar Sekunden"
        },
        "creditCard": {
            "no_cards_yet": {
                "title": "Keine finway-Karten verfügbar",
                "message": "Ihre erstellten Karten werden hier aufgelistet werden."
            },
            "no_active_cards": {
                "title": "Keine aktive finway-Karten verfügbar",
                "message": "Ihre aktiven Karten werden hier aufgelistet werden."
            }
        },
        "inbox": {
            "title": "Ihr Eingang ist leer",
            "message": "Alle eingehenden Rechnungen werden hier aufgelistet."
        },
        "funding_history": {
            "title": "Keine Funding Transaktionen",
            "message": "Sobald Sie Geld an Ihren Wallet senden, wird dies hier aufgelistet werden."
        },
        "account_statements": {
            "title": "Keine Kontoauszüge verfügbar",
            "message": "Der erste Kontoauszug wird gegen Ende des ersten Monats hier erscheinen."
        },
        "folder": {
            "message": "Es wurde bisher kein Antrag hinzugefügt."
        },
        "wallet_iban_process": {
            "title": "Wallet Erstellung in Bearbeitung",
            "message": "Bitte klicken Sie den Button, um den Erstellungsprozess des Wallets fertigzustellen."
        }
    },
    "sepa_xml_already_generated": "SEPA-XML wurde bereits erstellt.",
    "finish_web_form": "Bitte bearbeiten Sie das Webformular...",
    "fetching_bank_transactions": "Banktransaktionen werden ermittelt...",
    "more_interfaces_available": "Wenn nicht alle Accounts angezeigt werden, versuchen Sie bitte weitere Interfaces zu verbinden.",
    "expense_filter": {
        "amount": "Bei Abonnements bezieht sich dies auf den jährlichen Preis."
    },
    "matched": "Matched",
    "connecting": "Am Verbinden",
    "downloading": "Am Herunterladen",
    "downloaded": "Heruntergeladen",
    "failed": "Fehlgeschlagen",
    "click_to_repair": "zum Reparieren klicken",
    "action_in_progress": "Aktion wird ausgeführt...",
    "action_required": "Aktion erforderlich",
    "matching": {
        "csv_mapping_verify": "Bitte überprüfen Sie, ob die Spalten richtig erkannt wurden.",
        "csv_mapping_verify_description": "Wenn alle Werte der folgenden Parameter identisch sind, wird die Transaktion nur einmal importiert, um Duplukate zu vermeiden: Betrag, Datum, IBAN, Lieferant und Beschreibung.",
        "card_transaction_info": "Diese Transaktion ist eine Kartentransaktion. Der Matching-Prozess mit der Ausgabe passiert automatisch und sollte nicht manuell verändert werden.",
        "cash_card_transaction_info": "Diese Transaktion repräsentiert eine Geldabhebung einer Karte. Diese Arten von Transaktionen werden in finway nicht verarbeitet.",
        "pending_transaction_info": "Diese Transaktion ist ausstehend und wurde noch nicht ausgeführt.",
        "failed_transaction_info": "Diese Transaktion ist fehlgeschlagen.",
        "failed_transaction_info_for_reason": "Diese Transaktion ist fehlgeschlagen mit folgendem Grund: {{reason}}.",
        "import_in_progress": {
            "title": "Importieren von Transaktionen",
            "message": "Banktransaktionen werden gerade importiert. Dies kann einige Minuten dauern."
        },
        "matching_in_progress": {
            "title": "Matchen von Transaktionen",
            "message": "Banktransaktionen werden gerade mit Anträgen ge-matched. Dies kann einige Minuten dauern."
        },
        "pending_bank_transaction": {
            "message": "<0> Transaktion im Status Pending: </0> Diese Transaktion befindet sich im Status Pending, da die Bank noch keine Statusrückmeldung zur Zahlung gegeben hat. Wenn der Status mehrere Tage lang Pending bleibt, empfehlen wir, Ihre Bank bzgl. weiterer Details zu kontaktieren.",
            "tooltip": "Diese Transaktion im Status Pending wartet auf ein update der Bank"
        }
    },
    "email_verification_needed": {
        "title": "Verifikation nötig",
        "message": "Ihre neue Email-Adresse wird aktiv sobald sie verifiziert wurde."
    },
    "loading_data": "Daten werden geladen...",
    "no_search_data_found": {
        "title": "Keine Ergebnisse gefunden",
        "message": "Bitte versuchen Sie es mit einem anderen Suchbegriff."
    },

    "no_filter_data_found": {
        "title": {
            "vendor": "Kein Lieferant gefunden.",
            "employee": "Kein Mitarbeiter:in gefunden.",
            "cost_center_1": "Keine Kostenstelle gefunden.",
            "cost_center_2": "Keine Kostenträger gefunden.",
            "transaction": "Keine Transaktion gefunden.",
            "workflow": "Kein Workflow gefunden.",
            "subscription": "Kein Abonnement gefunden.",
            "card": "Keine Karte gefunden.",
            "purchase_order": "Keine Bestellung gefunden.",
            "delivery_note": "Kein Lieferschein gefunden."
        },
        "message": "Bitte versuchen Sie eine andere Sucheingabe oder fügen einen neuen Eintrag hinzu.",
        "message_approver": "Bitte versuchen Sie eine andere Sucheingabe."
    },
    "no_linking_data_found": {
        "invoice": {
            "preview": "Sie können Rechnungen erst verknüpfen, wenn die Bestellung vollständig genehmigt ist.",
            "enabled": "Sie können jetzt Rechnungen zu dieser Bestellung verknüpfen."
        },
        "delivery_note": {
            "preview": "Sie können Lieferscheine erst verknüpfen, wenn die Bestellung vollständig genehmigt ist.",
            "enabled": "Sie können jetzt Lieferscheine zu dieser Bestellung verknüpfen."
        }
    },
    "cards": {
        "pin_blocked": "Der PIN für diese Karte ist aufgrund von zu vielen Fehleingaben gesperrt. Bitte kontaktieren Sie den finway Support, um die Karte zu entsperren. Erst nachdem der finway Support die Karte entsperrt hat, kann ein Admin Ihre Karte in den Optionen entsperren.",
        "one_time_card_creation_on_approval": "Bei Freigabe dieses Antrags wird eine virtuelle Karte erstellt, die nur einmal und für diesen Antrag benutzt werden kann. Der/die Antragssteller:in wird als Karteninhaber:in gesetzt.",
        "subscription_card_creation_on_approval": "Bei Freigabe dieses Antrags wird eine virtuelle Karte erstellt, die zum Abonnement hinzugefügt wird. Der/die Antragssteller:in wird als Karteninhaber:in gesetzt.",
        "window": {
            "no_edit_sub_card": "Abgeleitet vom verbundenem Abo.",
            "no_edit_one_time_card": "Abgeleitet vom verbundenem Antrag."
        },
        "ask_admin_to_issue": "Fragen Sie einen Admin um eine Karte zu erstellen.",
        "card_being_generated": "Die Karte wird momentan erstellt. Dies kann bis zu einer Minute dauern.",
        "fetching_pin": "Laden vom PIN...",
        "card_pin_info": "Nachfolgend ist der PIN für Ihre physische Karte. Dieser kann nur an einem Bankautomaten geändert werden.",
        "finish_onboarding_part_one": "Sie sind für das Kartenprogramm angemeldet worden. Bitte schließen Sie ",
        "finish_onboarding_part_two": " ab, um ihre Karte nutzen zu können.",
        "finish_onboarding_mobile": "Sie sind für das Kartenprogramm angemeldet, aber Ihre Telefonnummer ist nicht verifiziert. Bitte vervollständigen Sie ",
        "disabled_auto_recharge": "Diese Karte kann nicht automatisch aufgeladen werden.",
        "cannot_change_requester_with_attached_card": "Der/die Antragsteller:in kann nicht gewechselt werden, da bereits eine Karte erstellt wurde.",
        "demo": {
            "title": "Dies ist eine Demo-Instanz.",
            "message": "Das heißt, dass dies keine echten Karten sind und somit nicht für einen echten Einkauf benutzt werden können."
        },
        "limit_padded": "Dieser Betrag wurde dem Limit hinzugefügt, um mögliche Währungsschwankungen auszugleichen. Es handelt sich nicht um eine Gebühr.",
        "limit_change_request": "{{userName}} hat eine Limitänderung für Karte '{{cardName}}' angefordert",
        "current_limit_and_requested_limit": "Aktuelles Limit: {{currentLimit}}. Angefordertes Limit: {{requestedLimit}}.",
        "pending_limit_request": "Ausstehende Anfrage für eine Limit-erhöhung dieser Karte auf {{requestedLimit}}.",
        "bank_transfer_funding": "Ihr Wallet ist Ihr finway-Bankkonto, das mit Ihren finway-Karten verbunden ist. Damit Sie Ihre Karten nutzen können, stellen Sie bitte sicher, dass Ihr Wallet ausreichend gedeckt ist. Tätigen Sie hierzu eine Banküberweisung auf das folgende Konto, um Ihr finway-Wallet aufzuladen. Bei Überweisungen von mehr als 100.000 € innerhalb von 30 Tagen sind wir verpflichtet, die Herkunft der Gelder zu überprüfen. In diesem Fall müssen Sie möglicherweise ein digitales Source-of-Funds-Formular (SoF) ausfüllen. Bis die Prüfung abgeschlossen ist, bleibt der Betrag vorübergehend gesperrt. Für Softortüberweisungen, die innerhalb von 30 Tagen 30.000 € überschreiten, wird die Zahlung sofort und ohne Überprüfung abgelehnt. <0>Mehr Info hier</0>",
        "direct_bank_transfer_funding": "Ihr Wallet ist Ihr finway-Bankkonto, das mit Ihren finway-Karten verbunden ist. Damit Sie Ihre Karten nutzen können, muss sich ausreichend Guthaben in Ihrem Wallet befinden. Bitte geben Sie unten den Betrag ein, den Sie von Ihrem Standard-Bankkonto überweisen möchten. Bei Überweisungen von mehr als 100.000 € innerhalb von 30 Tagen sind wir verpflichtet, die Herkunft der Gelder zu überprüfen. Gegebenenfalls erhalten Sie ein digitales Formular zur Angabe der Geldquelle. Bis die Prüfung abgeschlossen ist, bleibt der Betrag vorübergehend gesperrt. <0>Mehr Info hier</0>",
        "bank_transfer_link": "https://help.finway.de/de/articles/160658-finway-wallet-bezahlung-mit-den-karten",
        "physical_card_costs": "Eine physische Karte kostet 3 EUR pro Monat.",
        "alternative_email_address_required": {
            "title": "Alternative Email Adresse benötigt",
            "message": "Um das Kartenprogramm für diese Firma zu verifizieren und zu verwalten, muss eine alternative Email-Adresse eingeben werden, da die primäre Email-Adresse bereits in einer anderen Firma verwendet wurde."
        },
        "limit_buffer": "€ {{available}} Limit-Puffer verfügbar",
        "limit_buffer_spent": "Limit-Puffer bereits aufgebraucht",
        "update_expense_amount_on_card_transaction": "Kartentransaktionen passen den Betrag der automatisch generierten, ge-matchten Anträge automatisch an.",
        "ask_support_to_enable_card_program": "Bitte kontaktieren Sie den Support, um das Kartenprogramm zu aktivieren.",
        "ask_support_to_enable_multi_currency_wallet": "Bitte kontaktieren Sie den Support, um den Wallet in verschiedenen Währungen zu aktivieren.",
        "bin_type_warning": "German BIN ausgewählt, bitte beachten Sie, dass derzeit Apple Pay und Google Pay noch nicht unterstützt werden.",
        "card_phone_number_deprecated": "Ist für diese Karte möglicherweise aufgrund einer älteren Systemhinterlegung eine falsche Telefonnummer gespeichert? Bitte wenden Sie sich in diesem Fall an unser Support-Team. Wir aktualisieren die Telefonnummer gerne für Sie."
    },
    "corporate": {
        "user_pincode_info": "Aus Sicherheitsgründen, muss eine 4-stelliger finway PIN erstellt werden, die für bestimmte Interaktionen mit Karten abgefragt wird. Nach Abfrage und erfolgreicher Eingabe ist diese finway PIN für 5 Minuten gültig. Zudem ist Ihr finway PIN Ihrem Account zugeordnet und sollte nicht mit anderen geteilt werden.",
        "email_verification": "Aus Sicherheits- und Compliance-Gründen müssen wir Ihre E-Mail-Adresse verifizieren. Eine E-Mail mit einem Bestätigungscode wurde an Ihre E-Mail-Adresse gesendet. Bitte geben Sie den Code SOFORT (maximale Gültigkeit: eine Stunde) unten ein und klicken Sie auf „Weiter“, um fortzufahren.",
        "mobile_verification": "Aus Sicherheits- und Compliance-Gründen müssen wir auch Ihre Mobilnummer verifizieren. Eine SMS mit einem Bestätigungscode wurde an Ihre Mobilnummer gesendet. Bitte geben Sie den Code SOFORT (maximale Gültigkeit: 5 Minuten) unten ein und klicken Sie auf „Weiter“, um fortzufahren.",
        "create_account": "Um den KYB Prozess erfolgreich abzuschließen, klicken Sie bitte den Button unten, um ein Geschäftskonto zu erstellen, das benutzt wird um Ihre Karten aufzuladen."
    },
    "auto_generated_request": "Dieser Antrag wurde automatisch erstellt.",
    "tax_deleted": "Dieser MwSt.-Satz wurde gelöscht.",
    "team_deleted": "Diese Abteilung wurde gelöscht.",
    "employee_deleted": "Dieser:n Mitarbeiter:in wurde gelöscht.",
    "employee_no_creditor_number": "Es wurde noch keine Kreditorennummer hinzugefügt. Diese wird für Reisenkostenerstattungen benötigt und für Rückerstattungsanträge empfohlen.",
    "employee_mileage_rate": "Hier können Sie einen individuellen Kilometersatz für diese:n Mitarbeiter:in hinterlegen (Cent/Kilometer). Dieser Satz wird bei Fahrtkosten-Erstattungsanträgen zugrunde gelegt.",
    "employee_mileage_rate_apply": "Für den/die Antragssteller:in ist ein individueller Kilometersatz ({{cent_rate}} Cent/Kilometer) hinterlegt, der in die Berechnung einfließt. ",
    "request_net_amount_mismatch": "Die Summe der Netto- oder Steuersatzbeträge stimmt nicht mit dem der Gesamt-Zeile überein -",
    "auto_generated_request_gross_amount_mismatch": "Der <strong>Gesamtbetrag (Brutto Ges.)</strong> stimmt nicht mit dem <strong>Transaktionsbetrag ({{transactionAmount}})</strong> überein. <br /> Wenn Sie fortfahren, wird der Antrag mit einem <strong>falschen Gesamtbetrag</strong> gespeichert. Bitte überprüfen Sie Ihre Eingaben, bevor Sie speichern.",
    "connected": "Verbunden",
    "disconnected": "Getrennt",
    "pending": "Ausstehend",
    "tax_mismatch": "Die Summe der Steuern stimmt nicht mit dem Steuerbetrag der Ausgabe überein.",
    "split_not_hundred_percent": "Der Prozentsatz für die Aufteilung der Ausgaben beträgt nicht 100",
    "split": {
        "rounding_error_detected": "Rundungsdifferenz durch Rechnungsaufteilung: Die (Gesamt-)Bruttobeträge sind für den Export nach DUO optimiert. Für den CSV-Export passen Sie die Beträge bitte ggf. manuell auf Zeilenbasis an (Betragsfelder sind entkoppelt).",
        "rounding_error_non_editable": "Rundungsdifferenz durch Rechnungsaufteilung wurde nicht manuell angepasst.",
        "has_vertical_discrepancy_gross": "Rundungsdifferenz durch Rechnungsaufteilung: Es bestehen Rundungsdifferenzen in den Bruttobeträgen (Bruttobeträge ergeben in der Summe nicht das Gesamtbrutto). Bitte korrigieren Sie die Bruttobeträge manuell für die Übertragung nach DUO.",
        "has_horizontal_discrepancy": "Rundungsdifferenz durch Rechnungsaufteilung: Es bestehen Rundungsdiskrepanzen auf Zeilenbasis (z.B. Netto + MwSt. entspricht nicht dem Brutto). Bitte passen Sie die Beträge manuell an, falls dies für Ihren CSV-Export oder andere Zwecke erforderlich ist.",
        "has_both_discrepancy": "Rundungsdifferenz durch Rechnungsaufteilung: Es wurden Rundungsabweichungen sowohl bei den Bruttobeträgen (Bruttobeträge ergeben nicht den Gesamtbruttobetrag), als auch auf Zeilenbasis festgestellt. Bitte korrigieren Sie die Beträge für den DATEV Export."
    },
    "filled_by_ocr": "Automatisch durch OCR extrahiert.",
    "missing_vendor_or_cc": {
        "title": "Fehlende Informationen",
        "message": "Dieser Antrag wurde automatisch generiert und Sie müssen manuell eine Kostenstelle und einen Lieferanten auswählen, bevor der Antrag weiter bearbeitet werden kann."
    },
    "missing_cc": {
        "title": "Fehlende Informationen",
        "message": "Bei diesem Antrag fehlen Kostenstellendaten. Erst dann kann dieser Antrag weiter bearbeitet werden."
    },
    "item_gross_total_mismatch": {
        "main": "Der Bruttogesamtbetrag der Posten ({{items_gross}}) stimmt nicht mit dem Bruttogesamtbetrag der Ausgaben ({{expense_gross}}) überein. -",
        "prompt": "jetzt korrigieren."
    },
    "banking": {
        "consent_required": "Die Bankverbindung {{bank_name}} ({{bank_code}}) benötigt Ihre Zustimmung, um Daten von der Bank abrufen zu können. ",
        "this_consent_required": "Diese Bankverbindung erfordert Ihre Zustimmung, um Daten von der Bank abrufen zu können. Automat. ",
        "currently_downloading": "Die Transaktionsdaten für die Bankverbindung {{bank_name}} ({{bank_code}}) werden geladen. Dieser Vorgang kann bis zu einem Tag dauern - bitte warten Sie, bis der Prozess abgeschlossen ist. ",
        "this_currently_downloading": "Die Transaktionsdaten für diese Bankverbindung werden geladen. Dieser Vorgang kann bis zu einem Tag dauern - bitte warten Sie, bis der Prozess abgeschlossen ist.",
        "automatic_payment_disabled": "Automat. Matching von Bankzahlungen ist derzeit deaktiviert.",
        "outdated_data_displayed": "Möglicherweise werden veraltete Daten angezeigt.",
        "balance_missing": "Kontostand ist nicht verfügbar",
        "balance_missing_due_consent": "Zustimmung zur Bankdatenabfrage fehlt: Kontostand ist nicht verfügbar",
        "potential_extra_payment_fee": "Unser System sendet nur Zahlungen in der Währung Euro. Wenn Sie Rechnungen in einer anderen Währung bezahlen, kann die Empfängerbank Gebühren für die Währungsumrechnung erheben, einschließlich Transaktionsgebühren für ausländische Banken außerhalb der EU. <0/> <0/> Prüfen Sie die Zahlungsdetails sorgfältig. Wenden Sie sich bei Fragen an die Empfängerbank. Wenn Sie auf \"Zahlung bestätigen\" klicken, bestätigen Sie diese Warnung gelesen zu haben."
    },
    "fetch_table_error": "Bitte laden Sie die Tabelle erneut, indem Sie auf \"Neu laden\" klicken oder die Seite aktualisieren",
    "liquidity_scenario": "Wählen Sie ein übergeordnetes Szenario für Ihre Planung aus.",
    "bu_code_datev_compliance": "Mindestens einer der BU Codes ist inkompatibel zu DATEV.",
    "bu_code_datev_compliance_detail_warning": "Eine oder mehrere BU Nummern, die in diesem Antrag verwendet werden, sind nicht kompatibel mit DUO. Falls Sie diesen Antrag nach DATEV exportieren möchten, ändern Sie bitte die BU Nummer(n).",
    "expense_account_code_datev_compliance": "Mindestens einer der Sachkonten Codes ist inkompatibel zu DATEV.",
    "consolidated_amount_unsafe_datev_compliance": "Der Gesamtbetrag des Antrags stimmt nicht mit der Summe der Items überein.",
    "wallet": {
        "auth_factor": {
            "auth_factor_needed": "Für den Auszahlungsvorgang benötigen Sie ein Authentifizierungsgerät - z. B. ein Mobiltelefon -",
            "verification_code_sent": "Ein Verifizierungscode wurde an Ihr Mobiltelefon gesendet. Mit diesem Code können Sie Ihr Mobiltelefon als Authentifizierungsgerät für den Auszahlungsprozess Ihres Guthabens hinterlegen."
        },
        "wire_transfer": {
            "verification_code_sent": "Ein Verifizierungs-Code wurde an Ihr Mobiltelefon gesendet. Bitte geben Sie diesen Code hier ein, um mit der Überweisung fortzufahren"
        },
        "verification_of_payee": {
            "result": {
                "MATCH": "Der von Ihnen angegebene Name stimmt mit dem für diese IBAN registrierten Namen überein. Sie können die Zahlung sicher ausführen.",
                "CLOSE_MATCH": "Der von Ihnen angegebene Name ähnelt dem für diese IBAN registrierten Namen, ist jedoch nicht identisch. Überprüfen Sie den registrierten Namen sorgfältig, bevor Sie die Zahlung ausführen – eine Überweisung auf das falsche Konto kann möglicherweise nicht rückgängig gemacht werden.",
                "NO_MATCH": "Der von Ihnen angegebene Name stimmt nicht mit dem auf dieser IBAN registrierten Namen überein. Wir empfehlen Ihnen dringend, diese Zahlung abzubrechen.",
                "NOT_POSSIBLE": "Der Name konnte nicht überprüft werden, da das empfangende Institut die Empfängerüberprüfung nicht unterstützt. Bitte prüfen Sie die Angaben zum Zahlungsempfänger sorgfältig, bevor Sie fortfahren."
            }
        },
        "generating_statements_in_progress": {
            "title": "Kontoauszüge werden generiert",
            "message": "Ein oder mehrere Kontoauszüge werden gerade generiert, dies kann etwas dauern."
        }
    },
    "download_the_sheet_file_template": "Bitte laden Sie die Vorlage-Datei herunter und füllen Sie diese aus. Im Anschluss können Sie diese im Upload-Bereich hochladen und Ihre Daten importieren.",
    "you_can_close_this_window": "Sie können dieses Fenster jetzt schließen. Eine Benachrichtigung mit den Upload-Ergebnissen erscheint, wenn der Vorgang abgeschlossen ist.",
    "validating_data": "Daten validieren...",
    "import_data": "Daten importieren...",
    "simply_get_started_by_downloading_our_template": "Beginnen Sie einfach, indem Sie unsere Vorlage herunterladen, Ihre Daten hinzufügen und auf finway hochladen.",
    "check_data_upload_result": "Sie können das Ergebnis des Daten-Uploads überprüfen und unten ein detailliertes Fehlerprotokoll finden.",
    "get_started_uploading_data": "Beginnen Sie mit dem Hochladen Ihrer Daten in finway!",
    "liquidity_management": {
        "opening_balance": "Eröffnungssaldo",
        "total_income": "Zahlungseingänge (gesamt)",
        "total_spending": "Zahlungsausgänge (gesamt)",
        "final_balance": "Endsaldo",
        "cashflow_cumulated": "Cashflow kumuliert",
        "planned_transaction_amount": "Erstellen Sie Prognosen für Zahlungseingänge über einen positiven Betrag, sowie Prognosen für Zahlungsausgänge über einen negativen Betrag (-).",
        "edit_planned_cashflow": "Geplante Transaktionen bearbeiten",
        "account_currency_alert": "Wenn Sie Ihre Bankkonten verbinden, beachten Sie bitte, dass das Tool derzeit nur eine Währung auf einmal verarbeiten kann.",
        "no_account_connected": "Bitte fügen Sie mindestens ein Konto hinzu, um Ihren Geldbestand sehen zu können.",
        "no_account_connected_banner": "Um Ihre tatsächlichen Daten sehen und das Tool optimal nutzen zu können, verbinden Sie bitte Ihr/e Bankkonto/-konten.",
        "no_forecast": "Um Ihren Soll-/Ist-Vergleich in dieser Chart sehen zu können, setzen Sie bitte zuerst Ihre Soll- bzw. Planzahlen im Cashflow Tab auf.",
        "percentages_are_rounded": "Prozentangaben auf ganze Zahlen gerundet."
    },
    "transaction_categories": {
        "default_creation": {
            "title": "Erstellung von Standardtransaktionskategorien",
            "message": "Standardtransaktionskategorien werden momentan erstellt. Dies kann einige Sekunden dauern. Bitte haben Sie etwas Gedult."
        }
    },
    "cannot_be_transferred_to_datev": "Diese Informationen dienen nur der internen Berichterstattung und können aufgrund von Datev-Einschränkungen nicht an Datev übertragen werden.",
    "archive": {
        "expense_initial_display": {
            "title": "Laden Sie Ihr Archiv, um alle Ausgaben anzuzeigen.",
            "message": "Klicken Sie hier, um einen Zeitraum auszuwählen oder die Filter-/Suchoption anzuwenden. So können Sie die notwendigen Daten laden.",
            "warning": "Suchen Sie nach Anträgen basierend auf der Rechnungsnummer, Beschreibung, Beschreibung/Anlass der Dienstreise, Artikelnamen, Antragsnummer,  Gesamtbetrag, Lieferanten, Antragssteller:in oder Genehmiger:in."
        },
        "transaction_initial_display": {
            "title": "Laden Sie Ihr Archiv, um alle Transaktionen anzuzeigen.",
            "message": "Klicken Sie hier, um einen Zeitraum auszuwählen oder die Filter-/Suchoption anzuwenden. So können Sie die notwendigen Daten laden."
        },
        "expenseArchiveAfterXDays_settings": "Die Berechnung des Archivierungszeitpunkts basiert auf dem Leistungsdatum. Die Ausgabe wird am Folgetag archiviert.",
        "transactionArchiveAfterXDays_settings": "Die Berechnung des Archivierungszeitpunkts basiert auf dem Transaktionsdatum. Die Transaktion wird am Folgetag archiviert.",
        "expense_search_info": "Der Archivierungszeitraum basiert auf dem Leistungsdatum.",
        "transaction_search_info": "Der Archivierungszeitraum basiert auf dem Transaktionsdatum."
    },
    "changing_the_limit_of_the_card_will_top_it_up": "Durch die Änderung des Karten-limits werden Debitkarten aufgeladen.",
    "sit_back_and_wait": "Aktion wird ausgeführt. Haben Sie etwas gedult.",
    "export_in_progress": "Export wird ausgeführt, dies kann etwas dauern.",
    "exported_as": "Exportiert als",
    "export_information": {
        "all": "Alle",
        "invoices": "Rechnungen",
        "datev_invoice_csv": "DATEV Beleg CSV"
    },
    "category_will_be_a_subcategory": "Wenn Sie dieses Feld setzen, wird die erstellte Kategorie eine Unterkategorie der ausgewählten übergeordneten Kategorie.",
    "upgrade_version": {
        "title": "Nutzen Sie das gesamte Finanzbetriebssystem",
        "1": "Ausgaben Management & Cashflow Planung in einem Tool",
        "2": "Reibungsfreie Prozessabbildung",
        "3": "Eine Single Source of Truth für Ihre Finanzdaten",
        "4": "Eingebettete Banking- und Bezahlfunktionen",
        "5": "3-Way-Matching & eingebettete OCR-Lösung",
        "6": "Physische und virtuelle Karten",
        "7": "Apple und Google Pay",
        "8": "Leistungsstake Workflows & Integrationen",
        "9": "Mobile Apps für Android & iOS",
        "10": "Lieferanten- & Abonnement-Management",
        "11": "Reporting and Echtzeit-Einblick in Ihre Daten"
    },
    "upgrade_banner": {
        "title": "Wählen Sie Ihr Abo und nutzen Sie das gesamte Finanzbetriebssystem.",
        "description": "Bündeln und digitalisieren Sie Ihre Finanzprozesse in einem einzigen Betriebssystem. Verwalten Sie alle Rechnungen, Abonnements, Genehmigungsprozesse und Karten ohne Reibungsverluste."
    },
    "not_categorizable": "Nicht kategorisierbar",
    "roles": {
        "system_rights": "System-Admin-Rechte erlauben es Rollen & Rechte, Unternehmen, Benutzer:innen und Logineinstellungen zu verwalten.",
        "auditor": "Auditor:innen können alles sehen, aber nichts bearbeiten. Wir empfehlen diese Rolle u.a. für Steuerberater:innen, die Zugang zu finway benötigen, oder für Revisoren im Rahmen von Audits oder Betriebsprüfungen.",
        "admin": "Admins können alles sehen und bearbeiten excl. System-Admin-Aufgaben. Wir empfehlen, diese Rolle zu nutzen, um die System- und Buchhaltungszuständigkeiten zwischen verschiedenen Benutzer:innen und Rollen  für GoBD konforme Nutzung von finway aufzuteilen.",
        "approver": "Genehmiger:innen entsprechen überwiegend Mitarbeiterrollen, können aber zusätzlich Anfragen genehmigen und als Genehmiger:innen in Workflows integriert werden. Zudem hat diese Rolle Sichtrechte auf alle Team-Anträge im gesamten Tool. Durch die Genehmigung von Kartenanträgen können auch Karten für diese Anträge erstellt werden.",
        "employee": "Mitarbeiter:innen können Anträge (Kauf-, Rechnungs, (Reise-) Rückerstattungsanträge) für einmalige oder wiederkehrende Ausgaben erstellen. Sie können eigene Anträge, Karten, Abonnements und Rechnungen einsehen, den Status ihrer Anträge einsehen und ihre eigenen Daten im Mitarbeiterbereich verwalten."
    },
    "per_diem": {
        "please_select": "Bitte wählen Sie alle Mahlzeiten und/oder Übernachtungen aus, die Ihr Unternehmen bezahlt oder zur Verfügung gestellt hat, oder die Sie separat vom Unternehmen erstattet bekommen.",
        "foreign_trip_prompt": "Bitte geben Sie nur bei Auslandsreisen das Land an, nicht bei Inlandsreisen",
        "total_reimbursable_amount": "Erstattungsfähiger Gesamtbetrag:",
        "transfer_date": "Ankunftsdatum von Ihrem nächsten Reiseziel",
        "transfer_time": "Lokale Ankunftszeit an Ihrem nächsten Reiseziel",
        "reimbursement_calc": "Die Minderung der (Halb-)tagespauschale für erhaltene Mahlzeiten (z. B. 20 % für Frühstück) bezieht sich auf den vollen Tagessatz. Hinweis für Halbtagespauschalen: Auch wenn der Gesamtabzug die Halbtagespauschale übersteigt, kann er niemals negativ sein und wird für diesen Tag auf 0 EUR gesetzt.",
        "reload": "Sie haben den Zeitraum geändert. Die Rückerstattungstabelle muss neu kalkuliert werden, bitte synchronisieren Sie die Tabelle erneut."
    },
    "expense_tag": {
        "not_found": "Keine Tags gefunden",
        "added_already": "Tag wurde bereits hinzugefügt"
    },
    "add_audit_trail_to_invoice_export": "Das Audit-Protokoll wird als zusätzliche Datei angehängt und in Exportformate mit Rechnungen aufgenommen, außer bei der DATEV Beleg CSV. Es kann auch manuell heruntergeladen werden. ",
    "vendor_creation_for_all": "Bei Aktivierung können alle Nutzer:innen des Unternehmens Lieferanten erstellen. Unabhängig von dieser Einstellung können alle Nutzer:innen Lieferanten vorschlagen.",
    "tagging_feature_enable": "Die Tagging-Funktion ermöglicht es Nutzer:innen, Anträge mit Tags zu versehen, z. B. um dringende Anträge zu markieren. Admins können Tags erstellen/löschen, andere Rollen können vorhandene Tags nur verwenden. Wenn Sie möchten, dass alle Personen Tags hinzufügen/löschen können, aktivieren Sie bitte auch die folgende Option.",
    "editing_tags_enable": "Ermöglichen Sie allen Nutzer:innen, neue Tags zu erstellen und zu löschen",
    "allow_all_to_update_absences": "Standardmäßig können nur Admins Abwesenheiten für sich selbst und andere Rollen einrichten. Wenn Sie diese Option aktivieren, können Mitarbeiter:innen und Genehmiger:innen zusätzlich ihre eigenen Abwesenheiten einrichten.",
    "show_cost_centers_ids": "Zeigt bei Aktivierung Kostenstellen IDs in z. B. allen Drop-down-Menüs in Antragseingabefeldern an",
    "sub_company_aliases": "Fügen Sie einen Email-Alias für jede Firma hinzu. Dies ist nötig, damit Sie bei mehreren Firmen gleichzeitig im Kartenprogramm registriert sein können. Diese Email wird nur während des KYB-Prozesses verwendet.",
    "custom_bank_subject": "Sie können den Verwendungszweck individualisieren und die Reihenfolge verändern, wie Sie wünschen. Die Vorlage, die Sie unten erstellen, wird automatisch bei Ihrer nächsten Zahlung angewandt.",
    "exchange": {
        "estimate": "Schätzung basierend auf*:",
        "paid": "Bezahlt am:",
        "settlement": "Abrechnung: "
    },
    "data_import_in_progress": "Datenimport läuft...",
    "expense_payment_flow_information": {
        "is_already_approved_and_paid_enabled": "Anträge (außer Kartenanträge) können als bereits genehmigt & bezahlt markiert erstellt werden und alle Phasen außer der Prüfung und des Exports werden übersprungen. Diese Einstellung schließt den \"Bereits bezahlt\"-Prozess aus.",
        "is_already_paid_enabled": "Anträge (außer Kartenanträge) können als bereits bezahlt markiert erstellt werden und alle Phasen außer der Prüfung und des Exports werden übersprungen.",
        "is_report_only_enabled": "Anträge (außer Kartenanträge) können lediglich für das Reporting erstellt werden, wodurch alle Phasen außer der Prüfung übersprungen werden."
    },
    "allow_workflow_adjustments": "Wenn aktiviert, können alle Nutzer:innen des Unternehmens Workflows anpassen. Wenn deaktiviert, können Workflows nur durch Nutzer:innen mit dem Recht: \"Überschreiben (Workflows)\" angepasst werden.",
    "enable_go_to_next_expense": "Wenn diese Einstellung aktiviert ist, ändert sich die Navigation nach der Genehmigung in der Antrags-Detailansicht: Das System navigiert zum nächsten Antrag mit demselben Status (anstatt den aktuellen Antrag im nächsten Status anzuzeigen). Gilt nur für den \"To-dos\"- und \"Prüfung\"-Tab.",
    "custom_datev_info": "Definieren Sie je Antragsart die Informationen, die als Notiz an DUO exportiert werden sollen. Bitte beachten Sie die Begrenzung auf 120 Zeichen. Bei Überschreitung der Zeichenbegrenzung werden die zusätzlichen Zeichen beim Export abgeschnitten.",
    "custom_datev_info_footer": "(120 Zeichen sind erlaubt für den Export nach DUO - zusätzliche Zeichen werden abgeschnitten)",
    "pending_vendor": "Lieferant noch nicht genehmigt",
    "approve_vendor": "Der Lieferant kann nach Genehmigung bearbeitet werden",
    "reject_vendor": "Ablehnung löscht den Lieferanten",
    "custom_datev_booking_footer": "(60 Zeichen sind erlaubt für den Export nach DUO - zusätzliche Zeichen werden abgeschnitten)",
    "custom_datev_booking": "Definieren Sie die Informationen, die Sie als Buchungstext an DUO übergeben möchten. Bitte beachten Sie die Begrenzung auf 60 Zeichen. Bei Überschreitung der Zeichenbegrenzung werden die zusätzlichen Zeichen beim Export abgeschnitten.",
    "mileage": {
        "above_threshold": "Die Gesamtstrecke dieser Reise hat die {{distance}}-Kilometer-Toleranz überschritten.",
        "above_threshold_prompt": {
            "1": "Die von Ihnen eingegebene Entfernung hat die zusätzliche Toleranz von {{distance}} km überschritten. Bitte",
            "2": "geben Sie einen Grund",
            "3": "für die Fortsetzung der Erstattung an"
        },
        "distance_buffer": "finway berechnet automatisch die optimale Route zwischen den Zielorten, jedoch können Nutzer:innen die Entfernung manuell ändern. Definieren Sie hier den Puffer für die Entfernung - bei einer Überschreitung werden Nutzer:innen nach dem Grund für die längere Distanz gefragt.",
        "date": "Verwendet als Leistungs- und Eigenbelegdatum. Bei mehrtägigen Fahrten kann zusätzlich ein Leistungszeitraum hinterlegt werden."
    },
    "debit_card_limit_buffer": "Ohne einen Limit-Puffer für Debitkarten-Anträge kann es zu abgelehnten Kartentransaktionen kommen. Wählen Sie Ihren Default-Limit-Puffer (%), um mögliche Transaktionsablehnungen zu vermeiden.",
    "datev_online_error": {
        "title": "Problem mit Ihrer DUO Verbindung",
        "invalid_grant": "Wir haben ein Problem mit Ihrer DUO Verbindung entdeckt. Bitte versuchen Sie den Account neu zu verbinden oder kontaktieren Sie unseren Support.",
        "account_not_found": "Auf Ihren DUO Account konnte nicht zugegriffen werden. Dies kann zum Beispiel passieren, wenn Sie ihn woanders verlinkt haben. Wir haben den Account automatisch getrennt - bitte verbinden Sie ihn erneut in den Einstellungen."
    },
    "data_validation_result_below": "Finden Sie unten das Ergebnis der Daten-Upload-Validierung. Wenn es einen Fehler gibt, beheben Sie diese bitte vollständig, bevor Sie fortfahren.",
    "data_validation_empty_sheet": "Ihre Vorlage-Datei ist leer. Bitte stellen Sie sicher, dass Sie der Datei Daten hinzugefügt haben.",
    "data_import_result_below": "Finden Sie unten das Ergebnis des Daten-Upload-Imports.",
    "the_following_entries_will_be": "Die folgenden Einträge werden",
    "the_following_entries_have_been": "Folgende Einträge wurden",
    "total_imported_entries_on_date": "{{total}} Einträge importiert am {{date}}.",
    "on_row": "auf Reihe",
    "row": "Zeile",
    "select_fallback_approver": "Bitte wählen Sie eine:n Ersatz-Genehmiger:in aus einer Liste geeigneter Genehmiger:innen aus.",
    "export_change_history": {
        "message": "Hinweis",
        "description": "Die Zeitangaben werden in der Exportdatei im Format Universal Time Coordinate (UTC) angezeigt."
    },
    "fiscal_year": {
        "select": "Bitte geben Sie Ihr Geschäftsjahr an.",
        "dates": "{{start_date}} bis {{end_date}}"
    },
    "gross_amount_increased": "Bruttobetrag wurde erhöht",
    "csv_number_separator": {
        "title": "Empfehlung basierend auf Betriebssystem-Spracheinstellung:",
        "german_bold": "Deutsch (DE): ",
        "english_bold": "Englisch (US): ",
        "german": "CSV-Trennzeichen {;}, Dezimaltrennzeichen {,}",
        "english": "CSV-Trennzeichen {,}, Dezimaltrennzeichen {.}"
    },
    "auto_logout_suggestion": "Aus Sicherheitsgründen, empfehlen wir ein Auto-Logout Intervall von weniger als 24 Stunden. Die Einstellung tritt nach dem nächstem Login in Kraft.",
    "employee_absence_role": {
        "substitutes_not_set_up": "Bei Abwesenheiten übernehmen definierte Vertretungen die Genehmigung von Anträgen im Namen der ursprünglichen Genehmigenden.",
        "substitutes_set_up_link": "Vertretungen können in den <0>Benutzer-Einstellungen</0> konfiguriert werden.",
        "substitutes_set_up": "Bei Abwesenheit übernimmt die eingetragene Vertretung die Genehmigung von Anträgen. Die Vertretung wird zu Beginn der Abwesenheit automatisch informiert."
    },
    "employee_absence_substitutes_banner": {
        "message": "Abwesenheitsvertretungen einrichten",
        "description": "Sorgen Sie für einen reibungslosen Arbeitsablauf während Ihrer Abwesenheit! Weisen Sie Stellvertreter zu, damit Genehmigungen und Prozesse ohne Unterbrechungen weiterlaufen. \uD83D\uDE80",
        "button": "Benutzer-Einstellungen"
    },
    "active_substitution_banner": {
        "title": "Aktive Stellvertretung",
        "you_substituting": "Sie vertreten derzeit {{count}} Kolleg:innen:",
        "substituting_name_period": "<strong>{{name}}</strong> im Zeitraum <strong>{{start_date}}</strong> bis <strong>{{end_date}}</strong>",
        "substituting_1": "Sie vertreten derzeit <strong>{{name}}</strong> im Zeitraum <strong>{{start_date}}</strong> bis <strong>{{end_date}}</strong>.",
        "request_in_todo": "Anträge mit ausstehender Genehmigung finden Sie im Bereich To-Dos."
    },
    "request": {
        "update_expense_amount_on_card_transaction": "Kartentransaktionen passen den Betrag dieses Antrags automatisch an."
    },
    "datev_compliance_issues": "Dieser Antrag ist nicht kompatibel zu DATEV. Falls Sie diesen Antrag nach DATEV exportieren wollen, lösen Sie bitte erst folgende Probleme:",
    "zero_total_gross_datev_compliance": "Gesamtbruttobetrag von 0 ist nicht kompatibel zu DATEV.",
    "zero_item_gross_datev_compliance": "Mindestens ein Artikel hat einen Bruttobetrag von 0 und ist nicht kompatibel zu DATEV.",
    "enroll_fallback_approver": "Bitte registrieren Sie den/die ausgewählte:n Ersatz-Genehmiger:in im Kartenprogramm oder wählen Sie eine:n andere:n geeignete:n Ersatz-Genehmiger:in.",
    "folder": {
        "status": {
            "draft": {
                "title": "Reise einreichen",
                "description": "Bitte fügen Sie zuerst alle Reisekosten hinzu."
            },
            "invoice_pending": {
                "title": "Reise & Anträge freigeben",
                "description": "Die Freigabe gilt auch für die enthaltenen Anträge.",
                "tooltip": "Bezieht sich nicht auf bereits genehmigte Anträge."
            },
            "approved": {
                "title": "Diese Reise als geprüft markieren?",
                "description": "Alle enthaltenen Anträge werden als geprüft markiert.",
                "tooltip": "Bezieht sich nicht auf bereits geprüfte Anträge."
            },
            "reviewed": {
                "title": "Anträge in der Reise bezahlen",
                "description": "Bezahlen Sie Anträge in dieser Dienstreise.",
                "tooltip": "Bezieht sich nicht auf bereits bezahlte Anträge."
            },
            "paid": {
                "title": "Alle Anträge in dieser Reise exportieren?",
                "description": "Alle Anträge in dieser Reise exportieren.",
                "modal": {
                    "title": "Alle Anträge exportieren",
                    "description_1": "Ein oder mehrere Anträge wurden bereits exportiert.",
                    "description_1_format": "Ein oder mehrere Anträge wurden bereits als {{format}} exportiert.",
                    "description_2": " Bitte definieren Sie, ob alle, oder nur noch nicht exportierte Anträge exportiert werden sollen.",
                    "format": {
                        "csv": "CSV",
                        "csv_lexware": "CSV Lexware",
                        "datev": "DATEV-XML",
                        "datev_online": "DUO",
                        "sepa": "SEPA-XML",
                        "invoices": "Rechnungen"
                    },
                    "export_all": "Alle exportieren",
                    "only_not_exported": "Nur nicht Exportierte exportieren",
                    "confirm": "Exportieren",
                    "cancel": "Abbrechen",
                    "already_exported": {
                        "message_format": "Alle Ausgaben wurden bereits als {{format}} exportiert.",
                        "message": "Alle Ausgaben wurden bereits exportiert."
                    }
                }
            },
            "declined": {
                "title": "Abgelehnte Reise",
                "description": "Diese Reise wurde abgelehnt."
            },
            "done": {
                "title": "Vergangene Reise",
                "description": "Diese Reise wurde bereits verarbeitet."
            }
        }
    },
    "ignored_entries_because_they_exist_in_the_app": "Alle ignorierten Einträge ohne spezifische Details werden ignoriert, da sie bereits in der App vorhanden sind.",
    "expense_account_code_special_character_warning": "Wir empfehlen stark, diese Option NICHT zu aktivieren, falls Ihr Unternehmen nach DATEV exportiert. Diese Option ist dann nützlich, wenn Sie z.B. nach ADDISON exportieren. Wenn die Einstellung aktiviert ist, können Sie Sachkonten mit Sonderzeichen erstellen und eine DATEV XML für den ADDISON Import herunterladen.",
    "ocr_updates": {
        "modal_title": "OCR updates",
        "automatically_recognized_data": "Überschreibung durch automatisch erfasste Daten",
        "description": "Bitte überprüfen Sie die Daten welche OCR ausgelesen hat. Sie können pro Feld wählen ob der ursprüngliche Wert mit den von OCR ausgelesenen Daten überschrieben werden soll.",
        "updates_through_ocr": "Überschreibung durch OCR",
        "fields": "felder",
        "original": "ursprünglich",
        "new": "neu",
        "fields_names": {
            "invoiceNumber": "Rechnungsnummer",
            "invoiceDate": "Rechnungsdatum",
            "currency": "Währung",
            "invoiceDueDate": "Fällig am",
            "totalNetPrice": "Netto Ges.",
            "taxRate": "MwSt. (%)",
            "totalTaxPrice": "MwSt. Ges.",
            "totalGrossPrice": "Brutto Ges.",
            "vendor": "Lieferant",
            "name": "Artikel",
            "itemParent": "Artikel",
            "merchant": "Bewirtungsstätte",
            "performancePeriod": "Leistungszeitraum",
            "netPrice": "Netto Ges.",
            "grossPrice": "Brutto Ges.",
            "taxPrice": "MwSt. Ges.",
            "unitPrice": "Stückpreis",
            "quantity": "Menge",
            "description": "Beschreibung",
            "hospitalityDate": "Datum der Bewirtung",
            "performanceDate": "Leistungsdatum",
            "costCenter": "Kostenstelle",
            "costCenter2": "Kostenträger"
        }
    },
    "ask_support_to_enable_card_program": "Wenden Sie sich an unseren Support, um das Kartenprogramm zu aktivieren.",
    "datev_export_job": {
        "pending": "Der DUO-Export für diesen Antrag läuft bereits. Je nach Auslastung von DATEV kann die Verarbeitung etwas Zeit in Anspruch nehmen. Sie können den aktuellen Status jederzeit",
        "pending_button": "hier prüfen.",
        "failure_type_enum": {
            "MISSING_ACCOUNT_MONTH": "Der letzte DUO Export für diesen Antrag ist fehlgeschlagen, da der Buchungsmonat nicht in Ihrem verbundenem DUO Account konfiguriert ist.",
            "UNSUPPORTED_FILE_TYPE": "Der letzte DUO Export für diesen Antrag ist fehlgeschlagen, da der Antrag einer Rechnung enthält, die ein nicht unterstütztes Dateiformat enthält. Bitte versuchen Sie ein anderes Rechnungsdateiformat z.B. .pdf, .png, .jpeg",
            "ACCOUNT_NOT_FOUND": "Der letzte DUO-Export für diesen Antrag ist fehlgeschlagen, da auf Ihren DUO-Account nicht zugegriffen werden konnte. Dies kann beispielsweise daran liegen, dass der Account mit einer anderen Verbindung verknüpft wurde. Aus diesem Grund haben wir die Verknüpfung automatisch getrennt. Bitte verbinden Sie Ihren Account erneut in den Einstellungen.",
            "DAMAGED_INVOICE": "Der letzte DUO Export für diesen Antrag ist fehlgeschlagen, da die Rechnung ein falsches Dateiformat hat. Bitte versuchen Sie es mit einer anderen Rechnungsdatei.",
            "UNKNOWN": "Der letzte DUO Export für diesen Antrag ist fehlgeschlagen. Bitte versuchen Sie es erneut oder analysieren Sie das DATEV Importprotokoll, um mehr Informationen zu finden.",
            "JOB_NOT_FOUND": "Bitte versuchen Sie es erneut. Wenn der Fehler weiterhin besteht, kontaktieren Sie den finway Support und geben Sie den Fehlercode JOB_NOT_FOUND an.",
            "INVALID_DATEV_ACCESS_TOKEN": "Der letzte DUO Export ist bei mindestens einem Antrag fehlgeschlagen, da der DATEV-Zugangs-Token fehlt. Bitte in den Einstellungen verbinden."
        }
    },
    "approval_process": {
        "build_issue": {
            "title": "Der Freigabeprozess konnte nicht erstellt werden auf Basis des Workflows \"{{workflowName}}\", denn: ",
            "final_step_approvers_not_enrolled": "Genehmiger:in(nen) des letzten Freigabeschritts ist/sind nicht im Kartenprogramm registriert ({{approvers}}). Deshalb wurde ein weiterer Freigabeschritt hinzugefügt (Ersatz-Genehmiger:in).",
            "approver_is_requester": "Genehmiger:in ist Antragssteller:in ({{approver}}). Der/die Vorgesetzte:r konnte nicht alternativ als Genehmiger:in genutzt werden, da kein:e Vorgesetzte:r für diese: Antragssteller:in definiert wurde.",
            "fallback_approver_is_requester": "Alternative Freigabe war nicht erfolgreich, da der/die Fallback-Genehmiger:in der/die Antragssteller:in ist. ({{approver}})",
            "fallback_approver_not_enrolled": "Der/die Ersatz-Genehmiger:in ist nicht im Kartenprogramm registriert. ({{approver}})",
            "superior_not_enrolled": "Genehmiger:in ist Antragssteller:in ({{approver}}). Alternative Freigabe war nicht erfolgreich, da der/die Vorgesetzt:er nicht im Kartenprogramm registriert ist. ({{approver}})",
            "all_steps_skipped": "Sämtliche Workflow-Schritte werden übersprungen da die Anforderungen nicht erfüllt sind.",
            "estimated_past_steps": "Wir haben die Übersicht und Prognose der Genehmigungsprozesse verbessert. Für ältere Anträge könnten vorherige Freigaben inkorrekt  sein, können jedoch über die Kommentare nachvollzogen werden."
        }
    },
    "sso": {
        "has_been_de_forced": "Der verpflichtender login durch SSO wurde erfolgreich zurückgesetzt"
    },
    "duo_import_protocol_info": "Nur das Protokoll des letzten Exportvorgangs wird im Folgenden angezeigt.",
    "auth_error": {
        "login_failed": "Login fehlgeschlagen",
        "text": "Ihre Login anfrage ist leider fehlgeschlagen. Dies kann durch abgelehntes MFA, invalide SSO-Konfiguration oder fehlende Rechte passiert sein."
    },
    "gobd_compliance": {
        "ask_support_to_enable": "Die finway GmbH ermöglicht eine GoBD-konforme Arbeit nach IDW PS 880, aber sie übernimmt keine Produkthaftung für die von Ihnen gewählten Produkteinstellungen. GoBD-konformes Arbeiten kann weitereichende Auswirkungen bei z.B. einer Wirtschaftsprüfung verursachen. Lassen Sie sich bitte von Ihrem Steuerberater beraten bevor Sie eine Änderung anfragen. Mehr Infos <0>hier</0>. Bitte kontaktieren Sie den Support um GoBD-konformes Arbeiten zu aktivieren.",
        "link": "https://help.finway.de/de/articles/209564-gobd-zertifikat-umsetzung-in-finway"
    },
    "new_password_panel": {
        "password_policy": {
            "title": "Wir haben unseren Sicherheitsstandard erhöht, bitte erstellen Sie ein neues Passwort mit den folgenden Kriterien:",
            "1": "Darf nicht Ihre E-Mail-Adresse, Ihren Vornamen oder Nachnamen enthalten.",
            "2": "Muss mindestens 8 Zeichen lang sein.",
            "3": "Darf keine unangemessenen Formulierungen enthalten.",
            "4": "Muss mindestens ein Sonderzeichen enthalten (!, @, #, $, %, etc.)."
        }
    },
    "sync_per_diem_request": {
        "action": "Synchronisieren",
        "text": "Sie haben Änderungen vorgenommen. Die Rückerstattungstabelle muss neu kalkuliert werden, bitte synchronisieren Sie die Tabelle erneut."
    },
    "email_forwarding_address": "Sie können diese E-Mail-Adresse nutzen, um Ihre Rechnungen per E-Mail an Ihre finway Rechnungs Inbox weiterzuleiten.",
    "will_receive_reimbursement_payment": "erhält die Rückerstattungszahlung dieses Antrags",
    "reset_demo_data_in_progress": "Demodaten zurücksetzen wird ausgeführt, dies kann etwas dauern.",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "beneficiary": {
        "document_expired_warning": {
            "title": "Handlung erforderlich: Aktualisieren Sie Ihr Ausweisdokument für das finway Kartenprogramm",
            "message": "Das hinterlegte Ausweisdokument zur persönlichen Identifizierung von {{firstName}} {{lastName}} läuft am {{documentExpiryDate}} ab. Um Unterbrechungen zu vermeiden, laden Sie bitte ein gültiges Dokument hoch, anderenfalls werden Ihre Konten/Karten am {{identityRestrictionDate}} gesperrt. Erfahren Sie <0> hier</0>, wie Sie ein gültiges Dokument hochladen.",
            "link": "https://help.finway.de/de/articles/160661-kyb-prozess-kartenfunktionen-beantragen#h_f67e9b6d2b"
        },
        "account_restricted": {
            "title": "Handlung erforderlich: Ausweisdokument abgelaufen",
            "message": "Das hinterlegte Ausweisdokument zur persönlichen Identifizierung von {{firstName}} {{lastName}} ist abgelaufen. Solange kein gültiges Dokument hochgeladen wurde, sind Ihre Konten/Karten gesperrt. Erfahren Sie <0> hier</0>, wie Sie ein gültiges Dokument hochladen.",
            "link": "https://help.finway.de/de/articles/160661-kyb-prozess-kartenfunktionen-beantragen#h_f67e9b6d2b"
        }
    },
    "expense_discount": {
        "expired": {
            "title": "Warnung - Skontofrist überschritten",
            "message": "Ein oder mehrere Anträge enthalten eine überschrittene Skontofrist und werden daher bei der Zahlung nicht berücksichtigt. <br/> <0/> Nach der Zahlungsbestätigung werden alle überschrittenen Skonti automatisch von den Anträgen gelöscht."
        },
        "sepa_export": {
            "expired": {
                "title": "Warnung - Skontofrist überschritten",
                "message": "Eine oder mehrere Anfragen enthalten eine überschrittene Skontofrist.  Der volle Betrag ohne Skonto wird für die Zahlung berücksichtigt. <br/> <0/> Alle abgelaufenen Skonti werden automatisch aus dem Antrag entfernt, nachdem der Antrag als bezahlt markiert wurde."
            }
        }
    },
    "company_tz_change": "Sobald die Firma erstellt ist, können Sie die Zeitzone nicht mehr ändern. Wenden Sie sich wenn nötig bitte an Ihren Support-Manager.",
    "posting_period": {
        "tooltip": "Bildet die Periode ab, in welcher die Rechnung gebucht wird. <0>Mehr erfahren</0>.",
        "link": "https://help.finway.de/de/articles/200682-belegfunktion"
    },
    "data_uploader": {
        "entry_limit": "Alle Dateneingaben welche den 1000. Eintrag pro Blatt überschreiten werden nicht beim Import berücksichtigt."
    },
    "company_settings": {
        "update_sepa_version_help": "Bitte kontaktieren Sie den Support, um die SEPA xml Version zu aktivieren."
    },
    "employee_absence": {
        "modal": {
            "modal_headline": "Meine Vertretung",
            "primary_substitute": "Primäre Vertretung",
            "secondary_substitute": "Sekundäre Vertretung",
            "cancel": "Abbrechen",
            "save": "Speichern",
            "no_option": "Keine Daten",
            "no_secondary_substitute_set": "Keine Vertretung ausgewählt"
        },
        "not_card_program_alert_banner": {
            "title": "{{userName}} ist nicht Teil des Kartenprogramms",
            "message": "Kartenanträge werden entweder von einem Admin bearbeitet oder warten auf Ihre Rückkehr.",
            "more_info": "Mehr Informationen"
        }
    },
    "purchase_order": {
        "billing": {
            "message": "Bestellungen sind jetzt verfügbar!",
            "description_1": "Testen Sie unser erweitertes Bestellmanagement mit Verknüpfung zu Rechnungen auf Artikelebene kostenlos während der Pilotphase.",
            "description_2": "Premium-Funktionen werden später in kostenpflichtigen Plänen verfügbar sein.",
            "more_info": "Mehr Informationen",
            "link": "https://help.finway.de/de/articles/396998-bestellantrage-bestellungen-pos-und-rechnungsabgleich"
        },
        "card": {
            "one_time_card_creation_on_approval": "Eine Karte wird erstellt, sobald der Einkaufsantrag genehmigt wurde von einem Genehmiger:in.",
            "one_time_card_creation_on_procurement": "Eine Karte wird erstellt, sobald der Einkaufsantrag genehmigt wurde.",
            "one_time_card_missing": "Karte konnte nicht automatisch mit Genehmigung erstellt werden, da der Genehmiger:in nicht im Kartenprogramm war, bitte erstellen Sie die Karte manuell."
        },
        "empty_table": {
            "title": "Erstellen Sie Ihren ersten Bestellantrag",
            "text": "Erstellen Sie Ihren ersten Bestellantrag um ihn hier in einer Übersichtstabelle anzuzeigen.",
            "button": "Bestellantrag erstellen"
        }
    },
    "delivery_note": {
        "billing": {
            "message": "Lieferscheine sind jetzt verfügbar!",
            "description_1": "Nutzen Sie unser erweitertes Bestellmanagement jetzt auch mit Lieferscheinen. Verknüpfen Sie Lieferscheine mit Bestellungen auf Artikelebene kostenlos während der Pilotphase. ",
            "description_2": "Premium-Funktionen werden später in kostenpflichtigen Plänen verfügbar sein.",
            "more_info": "Mehr Informationen",
            "link": "https://help.finway.de/de/articles/425826-lieferschein-integration"
        },
        "empty_table": {
            "title": "Erstellen Sie Ihren ersten Lieferschein",
            "text": "Erstellen Sie Ihren ersten Lieferschein um ihn hier in einer Übersichtstabelle anzuzeigen.",
            "button": "Lieferschein erstellen"
        }
    },
    "skr42": "Wenn diese Option aktiviert ist, werden die Felder Kostenstelle und Kostenträger in allen Exportformaten vertauscht. Hinweis: Dies betrifft auch den Export nach DATEV Unternehmen Online.",
    "self_issued_receipt": "Nur verwenden, wenn der Originalbeleg fehlt – fehlende Originale können zu einem Verlust des Vorsteuerabzugs für Ihr Unternehmen führen. Mehr dazu in unserem <0>Help Center</0>.",
    "self_issued_receipt_link": "https://help.finway.de/de/articles/704918-eigenbeleg",
    "credit_note_negative_amount": "Die Beträge können wie auf der Gutschrift erfasst werden. Sie werden als negative Werte gespeichert.",
    "self_issued_receipt_reason": "Der Grund wird in Ihrem Eigenbeleg angegeben, der an diesen Antrag angehängt wird."
}
